export default function () {
    return navigator.userAgent.match(/kwaiying\/([\d.]+)/)?.[1] ?? '';
}
